// extracted by mini-css-extract-plugin
export var orderDetails = "_nf-2";
export var orderImage = "_nf-1";
export var orderMeta = "_nf-3";
export var orderSummary = "_nf-0";
export var rightArrow = "_nf-4";